GorgiasChat.init().then(function () {
    // Edit business hours on the go, if `Hide chat outside of business hours` is enabled, the chat will automatically appear or disappear.
    GorgiasChat.setCustomBusinessHours({
        // Using a timezone from https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
        // Day 1 represents Monday, Day 7 represents Sunday
        timezone: "America/Los_Angeles",
        businessHours: [
            { days: [1, 2, 3, 4, 5], fromTime: "04:10", toTime: "13:50" },
            { days: [6], fromTime: "04:10", toTime: "19:50" },
            { days: [7], fromTime: "04:10", toTime: "11:50" }
        ]
    });

    var chatDict = {
        actionPostbackError:"An error occurred while processing your action. Please try again.",
        backLabelBackAt: "Back online at {time}",
        backLabelBackInAMinute: "Back in 1 minute",
        backLabelBackInAnHour: "Back in 1 hour",
        backLabelBackInDays: "Back in {value} days",
        backLabelBackInHours: "Back in {value} hours",
        backLabelBackInMinutes: "Back in {value} minutes",
        backLabelBackOn: "Back on {weekday}",
        backLabelBackTomorrow: "Back soon",
        campaignClickToReply: "Click to reply",
        cannotUploadMoreFiles: "Cannot upload more than {maxFilesPerUpload} files at the same time.",
        characters: "characters",
        clickToRetry: "Click to retry.",
        contactFormAskAdditionalMessage: "Would you like to add any more information?",
        contactFormAskEmail: "How can we contact you?",
        contactFormAskMessage: "Got it! Share any additional details to help us assist you.",
        contactFormAskSubject: "What can we help you with?",
        contactFormAskSubjectOther: "Please type the subject:",
        contactFormEndingMessage: "Thanks for your message, we'll email you soon.",
        contactFormEndingMessageWithHelpCenter: "Thanks for your message, we'll email you soon. In the meantime, visit our Help Center!",
        contactFormIntro: "Leave a message and we'll email you once we're online.",
        contactFormSSPUnsuccessfulAskAdditionalMessage: "Sorry to hear that! Share any additional details to help us assist you.",
        conversationTimestampHeaderFormat: "MMMM D",
        emailCaptureInputLabel: "Get notified by email",
        emailCaptureOfflineThanksText: "Thanks {email}! We'll get back to you shortly.",
        emailCaptureOfflineTriggerText: "We're away, leave us your email and we'll respond shortly.",
        emailCaptureOnlineThanksText: "Thanks! We'll email you at {email} if you leave.",
        emailCaptureOnlineTriggerText: "Leave us your email and we will reply soon.",
        emailCaptureOnlineTriggerTextShortly: "Leave us your email and we'll get back to you shortly.",
        emailCapturePlaceholder: "your@email.com",
        emailCaptureRequiredEmailPlaceholder: "Leave your email",
        emailCaptureRequiredMessagePlaceholder: "Write your message",
        emailCaptureThanksText: "Thanks for reaching out! You'll get replies here and in your email.",
        emailCaptureTriggerBackOnlineAt: "We'll be back online at {time}",
        emailCaptureTriggerBackOnlineOn: "We'll be back online on {weekday}",
        emailCaptureTriggerTextBase: "Hi, thanks for contacting us. We've received your message and appreciate you reaching out.",
        emailCaptureTriggerTypicalReplyDay: "We typically reply in a day.",
        emailCaptureTriggerTypicalReplyHours: "We typically reply in a few hours.",
        emailCaptureTriggerTypicalReplyMinutes: "One of our amazing customer service reps will get back to you shortly. Thank you for your patience.",
        fetchHistory: "Load more",
        fetchingHistory: "Retrieving history...",
        fileTooBig: "File should be smaller than {maxFileSize} MB",
        getRepliesByEmail: "Get replies by email",
        headerText: "Gorgias Team",
        howCanWeHelpToday: "How can we help you today?",
        inputPlaceholder: "Type a message...",
        introductionText: "How can we help?",
        invalidFileError: "Only images are supported. Choose a file with a supported extension (jpg, jpeg, png, gif, or bmp).",
        leaveAMessage: "Leave A Message",
        leaveAnotherMessage: "Leave Another Message",
        messageDelivered: "Delivered",
        messageError: "An error occurred while sending your message. Please try again.",
        messageIndicatorTitlePlural: "({count}) New messages",
        messageIndicatorTitleSingular: "({count}) New message",
        messageNotDelivered: "Message not delivered. ",
        messageRelativeTimeDay: "{value}d ago",
        messageRelativeTimeHour: "{value}h ago",
        messageRelativeTimeJustNow: "Just now",
        messageRelativeTimeMinute: "{value}m ago",
        messageSending: "Sending...",
        messageTimestampFormat: "h:mm A",
        noAttachmentToSend: "No attachment to send",
        offlineIntroductionText: "We'll be back soon",
        poweredBy: "Powered by",
        poweredByGorgias: "Powered by Gorgias",
        productInformation: "Product information",
        productQuestionShort: "Product Question",
        requireEmailCaptureIntro: "Hi, hope you're doing well! Leave us your email so we can get back to you.",
        send: "Send",
        shopClosed: "{shopName} is now closed. Agents might not be available.",
        shopClosingInAMinute: "{shopName} is closing in 1 minute.",
        shopClosingInLessThanAMinute: "{shopName} is closing in less than 1 minute.",
        shopClosingSoon: "{shopName} is closing in {minutes} minutes.",
        subject: "Subject",
        tapToRetry: "Message not delivered. Tap to retry.",
        thanksForReachingOut: "Thanks for reaching out!",
        thatsAll: "That's all",
        unsupportedActionType: "Unsupported action type.",
        unsupportedMessageType: "Unsupported message type.",
        usualReplyTimeDay: "Typically replies within a day",
        usualReplyTimeHours: "Typically replies in a few hours",
        usualReplyTimeMinutes: "Typically replies in a few minutes",
        waitForAnAgent: "Wait for an agent",
        waitTimeAgentsAreBusy: "Thanks for reaching out! Our agents are currently busy. Your wait time is greater than 15 minutes.",
        waitTimeLongEmailCaptured: "Thank you for your patience. We'll get back to you as soon as agents are available",
        waitTimeLongHeader: "Wait time is longer than usual",
        waitTimeLongNoEmail: "Thank you for your patience. Leave us your email and we'll get back to you as soon as agents are available.",
        waitTimeMediumEmailCaptured: "Thanks for reaching out! An agent will get back to you in about {waitTime} minutes.",
        waitTimeMediumHeader: "We'll reply in a few moments",
        waitTimeMediumNoEmail: "Thanks for reaching out! Leave us your email and an agent will get back to you in about {waitTime} minutes.",
        waitTimeShortEmailCaptured: "Thanks for reaching out! An agent will get back to you soon.",
        waitTimeShortHeader: "We'll be right there!",
        waitTimeShortNoEmail: "Thanks for reaching out! Leave us your email and an agent will get back to you soon.",
    };

    window.GORGIAS_CHAT_TEXTS = chatDict;
    GorgiasChat.updateTexts(chatDict);
});
